import { SVGProps } from 'react';

interface AiBrainIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * AI Brain Icon
 *
 * Represents AI-powered learning features.
 * Neural network / brain design.
 */
export function AiBrainIcon({ size = 24, ...props }: AiBrainIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 3C7.5 3 4 6.5 4 11c0 2.5 1.2 4.7 3 6.1V19c0 .5.5 1 1 1h8c.5 0 1-.5 1-1v-1.9c1.8-1.4 3-3.6 3-6.1 0-4.5-3.5-8-8-8z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21v1M15 21v1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="9" cy="9" r="1.5" fill="currentColor" />
      <circle cx="15" cy="9" r="1.5" fill="currentColor" />
      <circle cx="12" cy="13" r="1.5" fill="currentColor" />
      <path
        d="M9 9l3 4M15 9l-3 4"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M6 8c-1 0-2 .5-2 1.5S5 11 6 11M18 8c1 0 2 .5 2 1.5s-1 1.5-2 1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
